/** The `status` values the login screen renders a dedicated state for. */
export const LOGIN_STATUS_QUERY = "status";

/** FLOW reported the authenticated person is not the applicant. */
export const LOGIN_STATUS_WRONG_USER = "wrongUser";

/** The flow has moved on to the signing document; no re-authentication needed. */
export const LOGIN_STATUS_DOCUMENT_SENT = "documentSent";

export const LOGIN_STATUS_FAILED = "failed";

export const LOGIN_STATUS_TIMEOUT = "timeout";

/** A step submit found the session unusable; the customer has to log in again. */
export const LOGIN_STATUS_SESSION_EXPIRED = "sessionExpired";
